import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import css from './section.module.css' 
const TeamMember = ({ data }) => {
  const { name, title, image } = data;
  return (
    <div className={css.team_member}>

      <div className={css.img_div}>
        <img src={image} alt="Team Member" />
        <ul className={css.social_icons}>
          <li>
            <Link className={css.link}>
              <FaLinkedin className={css.icon} />
            </Link>
          </li>
          <li>
            <Link className={css.link}>
              <FaTwitter className={css.icon} />
            </Link>
          </li>
          <li>
            <Link className={css.link}>
              <FaGithub className={css.icon} />
            </Link>
          </li>
          <li>
            <Link className={css.link}>
              <FaFacebook className={css.icon} />
            </Link>
          </li>
        </ul>
      </div>
    
    <h4>{name}</h4>
    <p>{title}</p>
    </div>
  );
};

export default TeamMember;
